import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";
import EditArea from "./components/EditArea";
import Messages from "./components/Messages";
import TypingIndicator from "./components/TypingIndicator";
import Zoom from "./components/Zoom";
import useSocket from "./hooks/useSocket";
import TranslationContext from "./providers/TranslationContext";
import withComponentOverride from "./withComponentOverride";
const SupportChatContainer = withComponentOverride(styled.div `
	display: flex;
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
	flex-direction: ${({ theme: { variant } }) => {
    return variant === "desktop" ? "column" : "column-reverse";
}};
	background: ${({ theme: { colors: { bgColor }, }, }) => {
    return bgColor;
}};

	&,
	* {
		box-sizing: border-box;
	}
`);
const SupportChat = ({ socketUrl, config, getAuthToken, style = {}, minFontSize = 12, maxFontSize = 20, fontSizeStep = 1, defaultFontSize = 14, autoMessage = "", alwaysShowZoom = false, showHeader = false, showAdditionalMessages = false, onFirstSupportMessageReceived, onSupportNickChanged, onKicked, onMessageFromSupportReceived, onShowTyping, onSupportFormSubmitted, defaultMessages, onMessageReceived, }) => {
    const translations = useContext(TranslationContext);
    const { lastMessage, sendMessage, typingChanged, isKicked, message, isConnected } = useSocket(socketUrl, config, getAuthToken, translations);
    const [showZoom, setShowZoom] = useState(false);
    const [fontSize, setFontSize] = useState(defaultFontSize);
    const [supportNick, setSupportNick] = useState("");
    const [conversationId, setConversationId] = useState("");
    const theme = useTheme();
    const { variant, components } = theme;
    const handleContainerMouseOver = useCallback(() => {
        if (variant === "mobile") {
            return;
        }
        setShowZoom(true);
    }, [variant]);
    const handleContainerMouseLeave = useCallback(() => {
        setShowZoom(false);
    }, []);
    useEffect(() => {
        if (autoMessage.length) {
            sendMessage(autoMessage);
        }
    }, [autoMessage, sendMessage]);
    useEffect(() => {
        if (!lastMessage) {
            return;
        }
        const { type, nick, conversationId: currentConversationId } = lastMessage;
        if (type === "support") {
            setSupportNick(nick);
            setConversationId(currentConversationId);
            if (onMessageFromSupportReceived) {
                onMessageFromSupportReceived(lastMessage);
            }
        }
    }, [lastMessage]);
    useEffect(() => {
        if (onFirstSupportMessageReceived) {
            onFirstSupportMessageReceived(supportNick, conversationId);
        }
        if (onSupportNickChanged) {
            onSupportNickChanged(supportNick);
        }
    }, [supportNick, conversationId]);
    useEffect(() => {
        if (isKicked && onKicked) {
            onKicked();
        }
    }, [isKicked]);
    useEffect(() => {
        if (onShowTyping) {
            onShowTyping(typingChanged);
        }
    }, [typingChanged]);
    useEffect(() => {
        if (onSupportFormSubmitted && message) {
            onSupportFormSubmitted();
        }
    }, [message]);
    useEffect(() => {
        // eslint-disable-next-line no-unused-expressions
        lastMessage && onMessageReceived?.(lastMessage);
    }, [lastMessage]);
    return (_jsxs(SupportChatContainer, { style: style, onMouseOver: handleContainerMouseOver, onMouseLeave: handleContainerMouseLeave, "data-testid": "support-chat", componentOverride: components?.SupportChatContainer, isConnected: isConnected, children: [(alwaysShowZoom || showZoom) && (_jsx(Zoom, { setFontSize: setFontSize, fontSize: fontSize, minFontSize: minFontSize, maxFontSize: maxFontSize, fontSizeStep: fontSizeStep })), _jsx(Messages, { lastMessage: lastMessage, fontSize: fontSize, isTyping: typingChanged, defaultMessages: defaultMessages, showHeader: showHeader, showAdditionalMessages: showAdditionalMessages }), variant === "desktop" && _jsx(TypingIndicator, { isTyping: typingChanged }), _jsx(EditArea, { sendMessage: sendMessage, isDisabled: !isConnected || isKicked })] }));
};
export default SupportChat;
